import { Button } from "flowbite-react";

interface NotEligibleProps {
    editHandler: () => void;
}

const NotEligible = ({ editHandler }: NotEligibleProps) => {
    return (
        <div className="flex flex-col justify-center items-center mt-10 max-w-[450px] gap-5  m-auto text-center">
            <img
                src={
                    "https://masai-website-images.s3.ap-south-1.amazonaws.com/svgviewer_png_output_2_2f4567da6b.png"
                }
                alt="Not Eligible"
            />
            <h1 className="text-[24px] text-[#3470E4] font-[700] leading-[32px]">Not Eligible For Upcoming Drives!</h1>
            <div className="flex gap-10">
                <Button
                    color={"whiteBlueOutline"}
                    onClick={() => {
                        editHandler();
                    }}
                >
                    Edit Details
                </Button>
            </div>
        </div>
    );
};

export default NotEligible;
